<div class="col-12 status-data">
  <div class="row" *ngFor="let row of rows">
    <div class="col-md-6 col-12">
      <span class="bold" *ngIf="row?.key">{{ row?.key | translate }}:</span>
    </div>
    <ng-container
      [ngTemplateOutlet]="row?.template ? row?.template : templateBaseFiled"
      [ngTemplateOutletContext]="{$implicit:row?.value}"
    ></ng-container>
  </div>
</div>

<ng-template #templateBaseFiled let-dataItem>
  <div class="col-md-6 col-12">{{ dataItem }}</div>
</ng-template>
